import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromPlant from '../_reducers/plant';

export const selectPlantState = createFeatureSelector<fromPlant.PlantState>('plants');

export const selectAllPlants = createSelector(selectPlantState, fromPlant.selectAll);

export const selectPlantEntities = createSelector(selectPlantState, fromPlant.selectEntities);

export const selectPlantById = (id: number) =>
  createSelector(selectPlantEntities, (entities) => entities[id]);

export const selectPlantTotal = createSelector(selectPlantState, fromPlant.selectTotal);
